import { FC, ReactElement } from 'react';

import { TopNavbar } from '../../containers';
import { useClientEffect } from '../../hooks';
import { fetchTopNavbar } from '../../redux/@blocks/topNavbar/topNavbarActions';
import { useTypedDispatch, useTypedSelector } from '../../redux/store';

interface ConnectedTopNavbarProps {
    className?: string;
}

export const ConnectedTopNavbar: FC<ConnectedTopNavbarProps> = ({
    className = '',
}): ReactElement => {
    const dispatch = useTypedDispatch();

    const topNavbarItems = useTypedSelector(state => state.topNavbarSlice.topNavbarItems);

    useClientEffect((): void => {
        dispatch(fetchTopNavbar());
    }, []);

    return (
        <TopNavbar
            links={topNavbarItems?.links || []}
            usps={topNavbarItems?.usps || []}
            className={className}
        />
    );
};
